var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminderOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.3335C6.15905 3.3335 4.66667 4.82588 4.66667 6.66683V10.0002C4.66667 10.1318 4.62771 10.2605 4.5547 10.37L3.91235 11.3335H12.0877L11.4453 10.37C11.3723 10.2605 11.3333 10.1318 11.3333 10.0002V6.66683C11.3333 4.82588 9.84095 3.3335 8 3.3335ZM3.33333 6.66683C3.33333 4.0895 5.42267 2.00016 8 2.00016C10.5773 2.00016 12.6667 4.0895 12.6667 6.66683V9.79831L13.888 11.6304C14.0244 11.8349 14.0371 12.098 13.9211 12.3147C13.8051 12.5315 13.5792 12.6668 13.3333 12.6668H2.66667C2.4208 12.6668 2.1949 12.5315 2.07888 12.3147C1.96287 12.098 1.97559 11.8349 2.11197 11.6304L3.33333 9.79831V6.66683Z",
    fill: "#334155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33333 11.6668C6.70152 11.6668 7 11.9653 7 12.3335C7 12.8858 7.44772 13.3335 8 13.3335C8.55228 13.3335 9 12.8858 9 12.3335C9 11.9653 9.29848 11.6668 9.66667 11.6668C10.0349 11.6668 10.3333 11.9653 10.3333 12.3335C10.3333 13.6222 9.28866 14.6668 8 14.6668C6.71134 14.6668 5.66667 13.6222 5.66667 12.3335C5.66667 11.9653 5.96514 11.6668 6.33333 11.6668Z",
    fill: "#334155"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 2.66683C6.66667 1.93045 7.26362 1.3335 8 1.3335C8.73638 1.3335 9.33333 1.93045 9.33333 2.66683C9.33333 3.03502 9.03486 3.3335 8.66667 3.3335C8.29848 3.3335 8 3.03502 8 2.66683C8 3.03502 7.70152 3.3335 7.33333 3.3335C6.96514 3.3335 6.66667 3.03502 6.66667 2.66683Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderOutline);
export default __webpack_public_path__ + "static/media/reminderOutline.68c7a394789e0113f2c96fd0fe68a729.svg";
export { ForwardRef as ReactComponent };